import { render, staticRenderFns } from "./ButtonCreateV2.vue?vue&type=template&id=37d10438&scoped=true"
import script from "./ButtonCreateV2.vue?vue&type=script&lang=js"
export * from "./ButtonCreateV2.vue?vue&type=script&lang=js"
import style0 from "./ButtonCreateV2.vue?vue&type=style&index=0&id=37d10438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d10438",
  null
  
)

export default component.exports